import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import LazyImage from 'components/shared/LazyImage';
import { HeadingFour, Text } from 'components/shared/Typography';

const Wrapper = styled.article`
  position: relative;
  width: calc(100% / 3);
  min-height: 600px;
  padding: 0 80px 80px 80px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: transparent
      linear-gradient(180deg, #00102e47 0%, #00102e 76%, #00102e 100%) 0% 0%
      no-repeat padding-box;
    z-index: 3;
  }

  @media screen and (max-width: 992px) {
    width: 100%;
    padding: 0 30px 30px 30px;
    min-height: 400px;
  }
`;

const Title = styled(HeadingFour)`
  margin: 0 0 25px 0;
`;

const Content = styled.div`
  position: relative;
  max-width: 320px;
  z-index: 4;
`;

const Background = styled(LazyImage)`
  position: absolute !important;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

const Tile = ({ image, title, text }) => {
  return (
    <Wrapper>
      <Background cover src={image} />
      <Content>
        <Title color="white">{title}</Title>
        <Text color="white">{text}</Text>
      </Content>
    </Wrapper>
  );
};

Tile.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default Tile;
